import React from "react";

const FilterPanel = () => {
  return <div>FilterPanel</div>;
};

export default FilterPanel;
